var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrow4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1625 4.99875C10.3119 4.99824 10.4595 5.03121 10.5945 5.09524C10.7295 5.15927 10.8484 5.25273 10.9425 5.36875L15.7725 11.3687C15.9196 11.5477 16 11.7721 16 12.0037C16 12.2354 15.9196 12.4598 15.7725 12.6387L10.7725 18.6387C10.6028 18.843 10.3589 18.9714 10.0944 18.9958C9.83001 19.0201 9.56673 18.9385 9.36251 18.7687C9.1583 18.599 9.02987 18.3551 9.00549 18.0907C8.98111 17.8262 9.06277 17.563 9.23251 17.3587L13.7025 11.9987L9.38251 6.63875C9.26023 6.49196 9.18255 6.31322 9.15867 6.12367C9.13479 5.93413 9.16571 5.7417 9.24776 5.56917C9.32982 5.39665 9.45958 5.25123 9.62169 5.15014C9.7838 5.04905 9.97148 4.99652 10.1625 4.99875Z",
    fill: "#eb2426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow4);
export default __webpack_public_path__ + "static/media/dropdown_arrow4.6dbab567122868254f360fa254530942.svg";
export { ForwardRef as ReactComponent };